import { ONE_MINUTE, ONE_SECOND } from '@lucidlink/uicore';
export const DEFAULT_PING_INTERVAL = 5 * ONE_SECOND;
const DEFAULT_MAX_MISSED_PINGS = 5;
export const LEGACY_MAX_MISSED_PINGS = 3;
const DEFAULT_RESPONSIVENESS_TIME_LIMIT = 5 * ONE_MINUTE;
export const getPingManager = ({ maxMissedPings = DEFAULT_MAX_MISSED_PINGS, onMaxMissedPings, pingFn, pingInterval = DEFAULT_PING_INTERVAL, responsivenessTimeLimit = DEFAULT_RESPONSIVENESS_TIME_LIMIT, }) => {
    let interval = null;
    let pingId = 0;
    let lastAcknowledgedPingTimestamp = 0;
    let maxAcknowledgeGap = 0;
    const activePings = new Map();
    const start = () => {
        if (interval) {
            return;
        }
        lastAcknowledgedPingTimestamp = Date.now();
        maxAcknowledgeGap = 0;
        interval = window.setInterval(() => {
            if (activePings.size === maxMissedPings) {
                stop();
                if (onMaxMissedPings) {
                    onMaxMissedPings();
                }
            }
            activePings.set(pingId, Date.now());
            pingFn(pingId);
            pingId++;
        }, pingInterval);
    };
    const stop = () => {
        if (interval) {
            clearInterval(interval);
            interval = null;
        }
        activePings.clear();
    };
    const acknowledgePing = (id) => {
        for (const activePingId of activePings.keys()) {
            if (activePingId <= id) {
                activePings.delete(activePingId);
            }
        }
        const now = Date.now();
        maxAcknowledgeGap = Math.max(maxAcknowledgeGap, now - lastAcknowledgedPingTimestamp);
        lastAcknowledgedPingTimestamp = now;
    };
    const getMaxAcknowledgeGap = () => Math.max(maxAcknowledgeGap, Date.now() - lastAcknowledgedPingTimestamp);
    const isPeerResponsive = () => Boolean(interval) &&
        Date.now() - lastAcknowledgedPingTimestamp < responsivenessTimeLimit;
    return {
        acknowledgePing,
        getMaxAcknowledgeGap,
        isPeerResponsive,
        start,
        stop,
    };
};
